import { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";

import { fetchFlexibleLandingPageData } from "./initData";
import { metaFlexiblePathReplacer } from "../../utils/page/library";

import MaybeError from "../../components/MaybeError/component";
import PageAnalytics from "../../components/PageAnalytics";

import { getLandingAnalytics } from "../../utils/analytics/library";
import { normalizeClass } from "../../utils/path/library";
import { TYPE_LANDING } from "../../utils/analytics/constants";
import { PAGE_COMPONENT_UNIVERSAL_CLASS_NAME } from "../../constants/page";
import { update_page_native_ad } from "../../actions/Page/dispatchers";
import Banner from "./components/Banner/component";
import PageHeadingContainer from "./components/PageHeadingContainer/component";
import { Sections } from "./components/Sections/component";
import { getSelection } from "../../hooks/useABTest/utils";
import { page_update_ad_test } from "../../reducers/Page/reducer";

const adTestGroupSelector = (state) => state.page.adTestGroup;

export const FlexibleLandingPage = ({
    match,
    fetch,
    viewport,
    analyticsEnabled = true,
    pageSelector = (state) => state.page,
}) => {
    const dispatch = useDispatch();

    const { path, baseSection, subSection, statusCode, meta } = useSelector(
        (state) => state.app
    );
    const page = useSelector(pageSelector);
    const analytics = useSelector((state) => state.tracking);
    const adTestGroup = useSelector(adTestGroupSelector);

    useEffect(() => {
        const url = metaFlexiblePathReplacer(match.url);
        const sanitizedPath = path === "homepage" ? "" : path;

        if (`/${sanitizedPath}` !== url) {
            dispatch(update_page_native_ad({ hasNativeAd: true }));
            const fetchAPI = fetch ?? fetchFlexibleLandingPageData;
            dispatch(fetchAPI(url, match.params));
        }

        if (match.url === "/news/canada") {
            getSelection("a-zcYvF5nFZM").then((result) => {
                dispatch(page_update_ad_test(result));
            });
        }
    }, [match.url, adTestGroup]);

    const pageClasses = classNames(
        "flexibleLandingPage",
        normalizeClass(baseSection, subSection, "landing"),
        PAGE_COMPONENT_UNIVERSAL_CLASS_NAME
    );

    const analyticsProps = getLandingAnalytics({ analytics, meta });
    return (
        <MaybeError statusCode={statusCode}>
            <div className={pageClasses} data-testid="flexible-landing-page">
                <Banner url={page?.bannerImage} />
                <PageHeadingContainer
                    pageHeading={page?.pageHeading}
                    headingVisible={page?.headingVisible}
                    description={page?.description}
                    timezoneText={page?.timezoneText}
                />
                <Sections
                    page={page}
                    viewport={viewport}
                    isNativeAd={page.hasNativeAd}
                />
                {analyticsEnabled && (
                    <PageAnalytics
                        dtmData={analyticsProps}
                        type={TYPE_LANDING}
                    />
                )}
            </div>
        </MaybeError>
    );
};

FlexibleLandingPage.propTypes = {
    match: PropTypes.object,
    location: PropTypes.object,
    pageHeadingHidden: PropTypes.bool,
    fetch: PropTypes.func,
    viewport: PropTypes.string,
    analyticsEnabled: PropTypes.bool,
};

export default FlexibleLandingPage;
